export const pageTitle_actionTypes = {
    CREATE_USER_ACCOUNT: "Create User Account",
    ACCOUNT_REQUEST_SUMMARY : "Account Request Summary",
    MODIFY_USER_ACCOUNT : "Modify User Account"
};